// src/components/auth/AuthTest.jsx
// Simple component to test Cognito authentication status

import React from 'react';
import { useCognitoAuth } from '../../aws-amplify-auth';
import { Button, Card, CardContent, Typography, Box, Alert } from '@mui/material';

const AuthTest = () => {
  const {
    isAuthenticated,
    loading,
    user,
    signOut,
    token
  } = useCognitoAuth();

  if (loading) {
    return (
      <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
        <CardContent>
          <Typography variant="h6">Loading authentication state...</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Authentication Test Component
        </Typography>
        
        <Box sx={{ mt: 2 }}>
          <Alert severity={isAuthenticated ? "success" : "info"} sx={{ mb: 2 }}>
            Status: {isAuthenticated ? "Authenticated" : "Not Authenticated"}
          </Alert>
          
          {isAuthenticated ? (
            <Box>
              <Typography variant="h6" gutterBottom>User Information:</Typography>
              <Typography>User ID: {user?.sub}</Typography>
              <Typography>Email: {user?.email}</Typography>
              <Typography>Name: {user?.name}</Typography>
              
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Token Info:</Typography>
              <Typography>
                Token: {token ? `${token.substring(0, 20)}...` : 'No token'}
              </Typography>
              
              <Button 
                variant="contained" 
                color="secondary" 
                onClick={signOut}
                sx={{ mt: 2 }}
              >
                Sign Out
              </Button>
            </Box>
          ) : (
            <Box>
              <Typography>
                You are not authenticated. Click the "Sign In" button in the header to log in.
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default AuthTest;
